module.exports = __webpack_public_path__ + "img/1920_yz.0a7cb5b7.png";